import React from 'react'
import '../css/main.css';

// import AddRoll from '../containers/AddRoll'
// import RollHistory from '../containers/RollHistory'
import CharacterQuiz from '../containers/CharacterQuiz'

/*
    <RollHistory />
    <div id="footer">
      <AddRoll />
    </div>
*/

const App = () => (
  <div>
    <CharacterQuiz />
  </div>
)

export default App



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/